var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuthResetSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 118.905,
    height: 68.104,
    viewBox: "0 0 118.905 68.104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_163",
    "data-name": "Group 163",
    transform: "translate(-7700.358 -2676.102)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    d: "M7718.5,2715.944s10.344-2.246,16.019.946c0,0,24.162,15.218,35.88-3.724,1.024-1.655,3.054-5,5.97-5.5a8.824,8.824,0,0,0,5.36-3.137c1.029-.192,2.117-.427,2.117-.427.222-.081.288-.425.288-.425a18.9,18.9,0,0,1,3.524-.041c-1.132-1.64-3.769-2.9-5.338-3.534-.524-2.1-2.442-5.528-9.469-3.756-2.2.555-3.989,1.545-6.324,2.034,1.231-6.578,4.1-18.577,9.132-22.279,0,0-4.729-.237-10.638,5.617,0,0-.172-2.134.684-3.054a14.032,14.032,0,0,0-6.939,6.532s.344-3.538.953-4.111c0,0-6.139,6.629-8.351,14.1-7.879-3.079-20.1-8.131-24.3-11.4,0,0-2.719,4.433,5.792,9.753a9.262,9.262,0,0,1-3.546-1.655s1.537,5.083,5.733,7.211a9.8,9.8,0,0,1-3.014-.887s1.95,4.02,4.492,5.2c0,0-4.02,3.783-8.748,3.783l-23.526-1.892s2.364,4.019,9.28,5.5a36.689,36.689,0,0,1-13.181,1.833S7706.151,2717.6,7718.5,2715.944Z",
    transform: "translate(0 0)",
    fill: "#b3e5e3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_154",
    "data-name": "Group 154",
    transform: "translate(7810.239 2707.726)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_153",
    "data-name": "Group 153"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    "data-name": "Path 398",
    d: "M7966.432,2751.319a1.184,1.184,0,0,0-1.655-.256l-4.271,3.129a1.184,1.184,0,1,0,1.4,1.91l4.271-3.129A1.183,1.183,0,0,0,7966.432,2751.319Z",
    transform: "translate(-7960.021 -2750.834)",
    fill: "#172345"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_156",
    "data-name": "Group 156",
    transform: "translate(7811.828 2720.193)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155",
    "data-name": "Group 155",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_399",
    "data-name": "Path 399",
    d: "M7970.371,2781.887l-5.066-1.54a1.184,1.184,0,1,0-.688,2.266l5.066,1.54a1.184,1.184,0,0,0,.689-2.266Z",
    transform: "translate(-7963.776 -2780.295)",
    fill: "#172345"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_158",
    "data-name": "Group 158",
    transform: "translate(7778.956 2702.127)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_157",
    "data-name": "Group 157"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_400",
    "data-name": "Path 400",
    d: "M7912.475,2754.557l-17.587,2.993-1.007-5.914a5.96,5.96,0,0,1,11.751-2l.4,2.334a1.183,1.183,0,0,0,1.365.968l4.669-.794a1.185,1.185,0,0,0,.969-1.366l-.4-2.335a13.064,13.064,0,0,0-25.757,4.384l1.04,6.115a3.558,3.558,0,0,0-1.772,3.7l2.4,14.085a3.557,3.557,0,0,0,4.1,2.906l23.422-3.986a3.556,3.556,0,0,0,2.906-4.1l-2.4-14.085A3.557,3.557,0,0,0,7912.475,2754.557Zm-23.263-2.126a10.7,10.7,0,0,1,21.089-3.589l.2,1.167-2.334.4-.2-1.167a8.328,8.328,0,0,0-16.419,2.794l1.006,5.914-2.335.4Zm27.423,19.514a1.186,1.186,0,0,1-.969,1.366l-23.424,3.986a1.185,1.185,0,0,1-1.365-.969l-2.4-14.085a1.185,1.185,0,0,1,.969-1.366l23.423-3.986a1.186,1.186,0,0,1,1.366.969Z",
    transform: "translate(-7886.095 -2737.604)",
    fill: "#172345"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_160",
    "data-name": "Group 160",
    transform: "translate(7791.5 2725.686)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_159",
    "data-name": "Group 159"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    "data-name": "Path 401",
    d: "M7918.7,2793.325a3.552,3.552,0,0,0-.009,7l.643,3.781a1.184,1.184,0,0,0,2.335-.4l-.644-3.781a3.551,3.551,0,0,0-2.325-6.6Zm.794,4.669a1.184,1.184,0,1,1,.969-1.365A1.185,1.185,0,0,1,7919.491,2797.994Z",
    transform: "translate(-7915.74 -2793.275)",
    fill: "#172345"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_162",
    "data-name": "Group 162",
    transform: "translate(7811.033 2714.73)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_161",
    "data-name": "Group 161"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    d: "M7967.553,2767.4l-4.669.794a1.184,1.184,0,1,0,.4,2.335l4.669-.795a1.184,1.184,0,1,0-.4-2.334Z",
    transform: "translate(-7961.898 -2767.384)",
    fill: "#172345"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthResetSuccess);
export default __webpack_public_path__ + "static/media/auth-reset-success.00acb94bc3296be04f0d6b0e6cbf1a9f.svg";
export { ForwardRef as ReactComponent };